module.exports = __webpack_public_path__ + "img/SWP_Staff_2H_01.e3dfe958.png";